module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "stdapplinf"
    }
  }, [_c('stdapplinf-detail', {
    attrs: {
      "labels": _vm.labels[_vm.app.nowLang],
      "data": _vm.index,
      "columns": _vm.columns[_vm.app.nowLang],
      "dataTappoinf": _vm.dataTappoinf,
      "receivedStdapplinfTappoinf": _vm.receivedStdapplinfTappoinf
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09c79938!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/stdapplinf/component.vue
// module id = 3527
// module chunks = 1